export const footerLinks = {
    'ru-ru': [
        {
            title: 'Популярные направления',
            items: [
                {
                    href: 'https://ru.wingie.com/flights/to-moscow/',
                    title: 'Москва',
                },
                {
                    href: 'https://ru.wingie.com/flights/to-vladivostok/',
                    title: 'Владивосток',
                },
                {
                    href: 'https://ru.wingie.com/flights/to-krasnodar/',
                    title: 'Краснодар',
                },
                {
                    href: 'https://ru.wingie.com/flights/to-new-york/',
                    title: 'Нью-Йорк',
                },
                {
                    href: 'https://ru.wingie.com/flights/to-london/',
                    title: 'Лондон',
                },
                {
                    href: 'https://ru.wingie.com/flights/to-amsterdam/',
                    title: 'Амстердам',
                },
            ],
        },
        {
            title: 'Популярные страны',
            items: [
                {
                    href: 'https://ru.wingie.com/flights/am-armenia/',
                    title: 'Армения',
                },
                {
                    href: 'https://ru.wingie.com/flights/az-azerbaijan/',
                    title: 'Азербайджан',
                },
                {
                    href: 'https://ru.wingie.com/flights/by-belarus/',
                    title: 'Беларусь',
                },
                {
                    href: 'https://ru.wingie.com/flights/eg-egypt/',
                    title: 'Египет',
                },
                {
                    href: 'https://ru.wingie.com/flights/ge-georgia/',
                    title: 'Грузия',
                },
                {
                    href: 'https://ru.wingie.com/flights/in-india/',
                    title: 'Индия',
                },
            ],
        },
        {
            title: 'Популярные авиакомпании',
            items: [
                {
                    href: 'https://ru.wingie.com/flights/airlines/azerbaijan-airlines/',
                    title: 'Azerbaijan Airlines',
                },
                {
                    href: 'https://ru.wingie.com/flights/airlines/pobeda/',
                    title: 'Pobeda',
                },
                {
                    href: 'https://ru.wingie.com/flights/airlines/nordwind-airlines/',
                    title: 'Nordwind Airlines',
                },
                {
                    href: 'https://ru.wingie.com/flights/airlines/rossiya-russian-airlines/',
                    title: 'Rossiya-Russian Airlines',
                },
                {
                    href: 'https://ru.wingie.com/flights/airlines/s7-airlines/',
                    title: 'S7 Airlines',
                },
                {
                    href: 'https://ru.wingie.com/flights/airlines/utair/',
                    title: 'Utair',
                },
            ],
        },
    ],
    'ru-en': [
        {
            title: 'Top Destinations',
            items: [
                {
                    href: 'https://ru.wingie.com/en/flights/to-moscow/',
                    title: 'Moscow',
                },
                {
                    href: 'https://ru.wingie.com/en/flights/to-vladivostok/',
                    title: 'Vladivostok',
                },
                {
                    href: 'https://ru.wingie.com/en/flights/to-krasnodar/',
                    title: 'Krasnodar',
                },
                {
                    href: 'https://ru.wingie.com/en/flights/to-new-york/',
                    title: 'New York',
                },
                {
                    href: 'https://ru.wingie.com/en/flights/to-london/',
                    title: 'London',
                },
                {
                    href: 'https://ru.wingie.com/en/flights/to-amsterdam/',
                    title: 'Amsterdam',
                },
            ],
        },
        {
            title: 'Popular Countries',
            items: [
                {
                    href: 'https://ru.wingie.com/en/flights/am-armenia/',
                    title: 'Armenia',
                },
                {
                    href: 'https://ru.wingie.com/en/flights/az-azerbaijan/',
                    title: 'Azerbaijan',
                },
                {
                    href: 'https://ru.wingie.com/en/flights/by-belarus/',
                    title: 'Belarus',
                },
                {
                    href: 'https://ru.wingie.com/en/flights/eg-egypt/',
                    title: 'Egypt',
                },
                {
                    href: 'https://ru.wingie.com/en/flights/ge-georgia/',
                    title: 'Georgia',
                },
                {
                    href: 'https://ru.wingie.com/en/flights/in-india/',
                    title: 'India',
                },
            ],
        },
        {
            title: 'Popular Airlines',
            items: [
                {
                    href: 'https://ru.wingie.com/en/flights/airlines/azerbaijan-airlines/',
                    title: 'Azerbaijan Airlines',
                },
                {
                    href: 'https://ru.wingie.com/en/flights/airlines/pobeda/',
                    title: 'Pobeda',
                },
                {
                    href: 'https://ru.wingie.com/en/flights/airlines/nordwind-airlines/',
                    title: 'Nordwind Airlines',
                },
                {
                    href: 'https://ru.wingie.com/en/flights/airlines/rossiya-russian-airlines/',
                    title: 'Rossiya-Russian Airlines',
                },
                {
                    href: 'https://ru.wingie.com/en/flights/airlines/s7-airlines/',
                    title: 'S7 Airlines',
                },
                {
                    href: 'https://ru.wingie.com/en/flights/airlines/utair/',
                    title: 'Utair',
                },
            ],
        },
    ],
    'ru-es': [
        {
            title: 'Principales destinos',
            items: [
                {
                    href: 'https://ru.wingie.com/es/vuelos/a-moscow/',
                    title: 'Moscow',
                },
                {
                    href: 'https://ru.wingie.com/es/vuelos/a-vladivostok/',
                    title: 'Vladivostok',
                },
                {
                    href: 'https://ru.wingie.com/es/vuelos/a-krasnodar/',
                    title: 'Krasnodar',
                },
                {
                    href: 'https://ru.wingie.com/es/vuelos/a-new-york/',
                    title: 'New York',
                },
                {
                    href: 'https://ru.wingie.com/es/vuelos/a-london/',
                    title: 'London',
                },
                {
                    href: 'https://ru.wingie.com/es/vuelos/a-amsterdam/',
                    title: 'Amsterdam',
                },
            ],
        },
        {
            title: 'Países populares',
            items: [
                {
                    href: 'https://ru.wingie.com/es/vuelos/am-armenia/',
                    title: 'Armenia',
                },
                {
                    href: 'https://ru.wingie.com/es/vuelos/az-azerbaijan/',
                    title: 'Azerbaiyán',
                },
                {
                    href: 'https://ru.wingie.com/es/vuelos/by-belarus/',
                    title: 'Bielorrusia',
                },
                {
                    href: 'https://ru.wingie.com/es/vuelos/eg-egypt/',
                    title: 'Egipto',
                },
                {
                    href: 'https://ru.wingie.com/es/vuelos/ge-georgia/',
                    title: 'Georgia',
                },
                {
                    href: 'https://ru.wingie.com/es/vuelos/in-india/',
                    title: 'India',
                },
            ],
        },
        {
            title: 'Aerolíneas populares',
            items: [
                {
                    href: 'https://ru.wingie.com/es/vuelos/companias-aereas/azerbaijan-airlines/',
                    title: 'Azerbaijan Airlines',
                },
                {
                    href: 'https://ru.wingie.com/es/vuelos/companias-aereas/pobeda/',
                    title: 'Pobeda',
                },
                {
                    href: 'https://ru.wingie.com/es/vuelos/companias-aereas/nordwind-airlines/',
                    title: 'Nordwind Airlines',
                },
                {
                    href: 'https://ru.wingie.com/es/vuelos/companias-aereas/rossiya-russian-airlines/',
                    title: 'Rossiya-Russian Airlines',
                },
                {
                    href: 'https://ru.wingie.com/es/vuelos/companias-aereas/s7-airlines/',
                    title: 'S7 Airlines',
                },
                {
                    href: 'https://ru.wingie.com/es/vuelos/companias-aereas/utair/',
                    title: 'Utair',
                },
            ],
        },
    ],
    'ru-de': [
        {
            title: 'Top-Destinationen',
            items: [
                {
                    href: 'https://ru.wingie.com/de/flug/nach-moskau/',
                    title: 'Moskau',
                },
                {
                    href: 'https://ru.wingie.com/de/flug/nach-wladiwostok/',
                    title: 'Wladiwostok',
                },
                {
                    href: 'https://ru.wingie.com/de/flug/nach-krasnodar/',
                    title: 'Krasnodar',
                },
                {
                    href: 'https://ru.wingie.com/de/flug/nach-new-york/',
                    title: 'New York',
                },
                {
                    href: 'https://ru.wingie.com/de/flug/nach-london/',
                    title: 'London',
                },
                {
                    href: 'https://ru.wingie.com/de/flug/nach-amsterdam/',
                    title: 'Amsterdam',
                },
            ],
        },
        {
            title: 'Beliebte Länder',
            items: [
                {
                    href: 'https://ru.wingie.com/de/flug/am-armenien/',
                    title: 'Armenien',
                },
                {
                    href: 'https://ru.wingie.com/de/flug/az-aserbaidschan/',
                    title: 'Aserbaidschan',
                },
                {
                    href: 'https://ru.wingie.com/de/flug/by-weissrussland/',
                    title: 'Weißrussland',
                },
                {
                    href: 'https://ru.wingie.com/de/flug/eg-aegypten/',
                    title: 'Ägypten',
                },
                {
                    href: 'https://ru.wingie.com/de/flug/ge-georgien/',
                    title: 'Georgien',
                },
                {
                    href: 'https://ru.wingie.com/de/flug/in-indien/',
                    title: 'Indien',
                },
            ],
        },
        {
            title: 'Beliebte Fluggesellschaften',
            items: [
                {
                    href: 'https://ru.wingie.com/de/flug/airlines/azerbaijan-airlines/',
                    title: 'Azerbaijan Airlines',
                },
                {
                    href: 'https://ru.wingie.com/de/flug/airlines/pobeda/',
                    title: 'Pobeda',
                },
                {
                    href: 'https://ru.wingie.com/de/flug/airlines/nordwind-airlines/',
                    title: 'Nordwind Airlines',
                },
                {
                    href: 'https://ru.wingie.com/de/flug/airlines/rossiya-russian-airlines/',
                    title: 'Rossiya-Russian Airlines',
                },
                {
                    href: 'https://ru.wingie.com/de/flug/airlines/s7-airlines/',
                    title: 'S7 Airlines',
                },
                {
                    href: 'https://ru.wingie.com/de/flug/airlines/utair/',
                    title: 'Utair',
                },
            ],
        },
    ],
    'ru-ar': [
        {
            title: 'أفضل الوجهات',
            items: [
                {
                    href: 'https://ru.wingie.com/ar/flights/to-moscow/',
                    title: 'موسكو',
                },
                {
                    href: 'https://ru.wingie.com/ar/flights/to-vladivostok/',
                    title: 'فلاديفوستوك',
                },
                {
                    href: 'https://ru.wingie.com/ar/flights/to-krasnodar/',
                    title: 'كراسنودار',
                },
                {
                    href: 'https://ru.wingie.com/ar/flights/to-new-york/',
                    title: 'نيويورك',
                },
                {
                    href: 'https://ru.wingie.com/ar/flights/to-london/',
                    title: 'لندن',
                },
                {
                    href: 'https://ru.wingie.com/ar/flights/to-amsterdam/',
                    title: 'أميستردام',
                },
            ],
        },
        {
            title: 'أشهر الدول',
            items: [
                {
                    href: 'https://ru.wingie.com/ar/flights/am-armenia/',
                    title: 'أرمينيا',
                },
                {
                    href: 'https://ru.wingie.com/ar/flights/az-azerbaijan/',
                    title: 'أذربيجان',
                },
                {
                    href: 'https://ru.wingie.com/ar/flights/by-belarus/',
                    title: 'بيلاروسيا',
                },
                {
                    href: 'https://ru.wingie.com/ar/flights/eg-egypt/',
                    title: 'مصر',
                },
                {
                    href: 'https://ru.wingie.com/ar/flights/ge-georgia/',
                    title: 'جورجيا',
                },
                {
                    href: 'https://ru.wingie.com/ar/flights/in-india/',
                    title: 'الهند',
                },
            ],
        },
        {
            title: 'أشهر الخطوط الجوية',
            items: [
                {
                    href: 'https://ru.wingie.com/ar/flights/airlines/azerbaijan-airlines/',
                    title: 'الخطوط الجوية الأذربي',
                },
                {
                    href: 'https://ru.wingie.com/ar/flights/airlines/pobeda/',
                    title: 'بوبيدا',
                },
                {
                    href: 'https://ru.wingie.com/ar/flights/airlines/nordwind-airlines/',
                    title: 'نورد ويند ايرلاينز',
                },
                {
                    href: 'https://ru.wingie.com/ar/flights/airlines/rossiya-russian-airlines/',
                    title: 'Rossiya-Russian Airlines',
                },
                {
                    href: 'https://ru.wingie.com/ar/flights/airlines/s7-airlines/',
                    title: 'الخطوط الجوية ال',
                },
                {
                    href: 'https://ru.wingie.com/ar/flights/airlines/utair/',
                    title: 'Utair',
                },
            ],
        },
    ],
    'ru-it': [
        {
            title: 'Principali destinazioni',
            items: [
                { href: 'https://ru.wingie.com/it/flights/to-moscow/', title: 'Mosca' },
                { href: 'https://ru.wingie.com/it/flights/to-vladivostok/', title: 'Vladivostok' },
                { href: 'https://ru.wingie.com/it/flights/to-krasnodar/', title: 'Krasnodar' },
                { href: 'https://ru.wingie.com/it/flights/to-new-york/', title: 'New York' },
                { href: 'https://ru.wingie.com/it/flights/to-london/', title: 'Londra' },
                { href: 'https://ru.wingie.com/it/flights/to-amsterdam/', title: 'Amsterdam' },
            ],
        },
        {
            title: 'Paesi popolari',
            items: [
                { href: 'https://ru.wingie.com/it/flights/am-armenia/', title: 'Armenia' },
                { href: 'https://ru.wingie.com/it/flights/az-azerbaijan/', title: 'Azerbaigian' },
                { href: 'https://ru.wingie.com/it/flights/by-belarus/', title: 'Bielorussia' },
                { href: 'https://ru.wingie.com/it/flights/eg-egypt/', title: 'Egitto' },
                { href: 'https://ru.wingie.com/it/flights/ge-georgia/', title: 'Georgia' },
                { href: 'https://ru.wingie.com/it/flights/in-india/', title: 'India' },
            ],
        },
        {
            title: 'Compagnie aeree popolari',
            items: [
                { href: 'https://ru.wingie.com/it/flights/airlines/azerbaijan-airlines/', title: 'Azerbaijan Airlines' },
                { href: 'https://ru.wingie.com/it/flights/airlines/pobeda/', title: 'Pobeda' },
                { href: 'https://ru.wingie.com/it/flights/airlines/nordwind-airlines/', title: 'Nordwind Airlines' },
                { href: 'https://ru.wingie.com/it/flights/airlines/rossiya-russian-airlines/', title: 'Rossiya-Russian Airlines' },
                { href: 'https://ru.wingie.com/it/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
                { href: 'https://ru.wingie.com/it/flights/airlines/utair/', title: 'Utair' },
            ],
        },
    ],
    'ru-fr': [
        {
            title: 'Principales destinations',
            items: [
                { href: 'https://ru.wingie.com/fr/flights/to-moscow/', title: 'Moscou' },
                { href: 'https://ru.wingie.com/fr/flights/to-vladivostok/', title: 'Vladivostok' },
                { href: 'https://ru.wingie.com/fr/flights/to-krasnodar/', title: 'Krasnodar' },
                { href: 'https://ru.wingie.com/fr/flights/to-new-york/', title: 'New York' },
                { href: 'https://ru.wingie.com/fr/flights/to-london/', title: 'Londres' },
                { href: 'https://ru.wingie.com/fr/flights/to-amsterdam/', title: 'Amsterdam' },
            ],
        },
        {
            title: 'Pays populaires',
            items: [
                { href: 'https://ru.wingie.com/fr/flights/am-armenia/', title: 'Arménie' },
                { href: 'https://ru.wingie.com/fr/flights/az-azerbaijan/', title: 'Azerbaïdjan' },
                { href: 'https://ru.wingie.com/fr/flights/by-belarus/', title: 'Biélorussie' },
                { href: 'https://ru.wingie.com/fr/flights/eg-egypt/', title: 'Égypte' },
                { href: 'https://ru.wingie.com/fr/flights/ge-georgia/', title: 'Géorgie' },
                { href: 'https://ru.wingie.com/fr/flights/in-india/', title: 'Inde' },
            ],
        },
        {
            title: 'Compagnies aériennes populaires',
            items: [
                { href: 'https://ru.wingie.com/fr/flights/airlines/azerbaijan-airlines/', title: 'Azerbaijan Airlines' },
                { href: 'https://ru.wingie.com/fr/flights/airlines/pobeda/', title: 'Pobeda' },
                { href: 'https://ru.wingie.com/fr/flights/airlines/nordwind-airlines/', title: 'Nordwind Airlines' },
                { href: 'https://ru.wingie.com/fr/flights/airlines/rossiya-russian-airlines/', title: 'Rossiya-Russian Airlines' },
                { href: 'https://ru.wingie.com/fr/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
                { href: 'https://ru.wingie.com/fr/flights/airlines/utair/', title: 'Utair' },
            ],
        },
    ],
    'ru-pt': [
        {
            title: 'Principais destinos',
            items: [
                { href: 'https://ru.wingie.com/pt/flights/to-moscow/', title: 'Moscou' },
                { href: 'https://ru.wingie.com/pt/flights/to-vladivostok/', title: 'Vladivostok' },
                { href: 'https://ru.wingie.com/pt/flights/to-krasnodar/', title: 'Krasnodar' },
                { href: 'https://ru.wingie.com/pt/flights/to-new-york/', title: 'Nova York' },
                { href: 'https://ru.wingie.com/pt/flights/to-london/', title: 'Londres' },
                { href: 'https://ru.wingie.com/pt/flights/to-amsterdam/', title: 'Amsterdã' },
            ],
        },
        {
            title: 'Países populares',
            items: [
                { href: 'https://ru.wingie.com/pt/flights/am-armenia/', title: 'Armênia' },
                { href: 'https://ru.wingie.com/pt/flights/az-azerbaijan/', title: 'Azerbaijão' },
                { href: 'https://ru.wingie.com/pt/flights/by-belarus/', title: 'Bielorrússia' },
                { href: 'https://ru.wingie.com/pt/flights/eg-egypt/', title: 'Egito' },
                { href: 'https://ru.wingie.com/pt/flights/ge-georgia/', title: 'Geórgia' },
                { href: 'https://ru.wingie.com/pt/flights/in-india/', title: 'Índia' },
            ],
        },
        {
            title: 'Companhias aéreas populares',
            items: [
                { href: 'https://ru.wingie.com/pt/flights/airlines/azerbaijan-airlines/', title: 'Azerbaijan Airlines' },
                { href: 'https://ru.wingie.com/pt/flights/airlines/pobeda/', title: 'Pobeda' },
                { href: 'https://ru.wingie.com/pt/flights/airlines/nordwind-airlines/', title: 'Nordwind Airlines' },
                { href: 'https://ru.wingie.com/pt/flights/airlines/rossiya-russian-airlines/', title: 'Rossiya-Russian Airlines' },
                { href: 'https://ru.wingie.com/pt/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
                { href: 'https://ru.wingie.com/pt/flights/airlines/utair/', title: 'Utair' },
            ],
        },
    ],
    'ru-ro': [
        {
            title: 'Top destinații',
            items: [
                { href: 'https://ru.wingie.com/ro/flights/to-moscow/', title: 'Moscova' },
                { href: 'https://ru.wingie.com/ro/flights/to-vladivostok/', title: 'Vladivostok' },
                { href: 'https://ru.wingie.com/ro/flights/to-krasnodar/', title: 'Krasnodar' },
                { href: 'https://ru.wingie.com/ro/flights/to-new-york/', title: 'New York' },
                { href: 'https://ru.wingie.com/ro/flights/to-london/', title: 'Londra' },
                { href: 'https://ru.wingie.com/ro/flights/to-amsterdam/', title: 'Amsterdam' },
            ],
        },
        {
            title: 'Țări populare',
            items: [
                { href: 'https://ru.wingie.com/ro/flights/am-armenia/', title: 'Armenia' },
                { href: 'https://ru.wingie.com/ro/flights/az-azerbaijan/', title: 'Azerbaidjan' },
                { href: 'https://ru.wingie.com/ro/flights/by-belarus/', title: 'Belarus' },
                { href: 'https://ru.wingie.com/ro/flights/eg-egypt/', title: 'Egipt' },
                { href: 'https://ru.wingie.com/ro/flights/ge-georgia/', title: 'Georgia' },
                { href: 'https://ru.wingie.com/ro/flights/in-india/', title: 'India' },
            ],
        },
        {
            title: 'Companii aeriene populare',
            items: [
                { href: 'https://ru.wingie.com/ro/flights/airlines/azerbaijan-airlines/', title: 'Azerbaijan Airlines' },
                { href: 'https://ru.wingie.com/ro/flights/airlines/pobeda/', title: 'Pobeda' },
                { href: 'https://ru.wingie.com/ro/flights/airlines/nordwind-airlines/', title: 'Nordwind Airlines' },
                { href: 'https://ru.wingie.com/ro/flights/airlines/rossiya-russian-airlines/', title: 'Rossiya-Russian Airlines' },
                { href: 'https://ru.wingie.com/ro/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
                { href: 'https://ru.wingie.com/ro/flights/airlines/utair/', title: 'Utair' },
            ],
        },
    ],
    'ru-pl': [
        {
            title: 'Najpopularniejsze kierunki',
            items: [
                { href: 'https://ru.wingie.com/pl/flights/to-moscow/', title: 'Moskwa' },
                { href: 'https://ru.wingie.com/pl/flights/to-vladivostok/', title: 'Władywostok' },
                { href: 'https://ru.wingie.com/pl/flights/to-krasnodar/', title: 'Krasnodar' },
                { href: 'https://ru.wingie.com/pl/flights/to-new-york/', title: 'Nowy Jork' },
                { href: 'https://ru.wingie.com/pl/flights/to-london/', title: 'Londyn' },
                { href: 'https://ru.wingie.com/pl/flights/to-amsterdam/', title: 'Amsterdam' },
            ],
        },
        {
            title: 'Popularne kraje',
            items: [
                { href: 'https://ru.wingie.com/pl/flights/am-armenia/', title: 'Armenia' },
                { href: 'https://ru.wingie.com/pl/flights/az-azerbaijan/', title: 'Azerbejdżan' },
                { href: 'https://ru.wingie.com/pl/flights/by-belarus/', title: 'Białoruś' },
                { href: 'https://ru.wingie.com/pl/flights/eg-egypt/', title: 'Egipt' },
                { href: 'https://ru.wingie.com/pl/flights/ge-georgia/', title: 'Gruzja' },
                { href: 'https://ru.wingie.com/pl/flights/in-india/', title: 'Indie' },
            ],
        },
        {
            title: 'Popularne linie lotnicze',
            items: [
                { href: 'https://ru.wingie.com/pl/flights/airlines/azerbaijan-airlines/', title: 'Azerbaijan Airlines' },
                { href: 'https://ru.wingie.com/pl/flights/airlines/pobeda/', title: 'Pobeda' },
                { href: 'https://ru.wingie.com/pl/flights/airlines/nordwind-airlines/', title: 'Nordwind Airlines' },
                { href: 'https://ru.wingie.com/pl/flights/airlines/rossiya-russian-airlines/', title: 'Rossiya-Russian Airlines' },
                { href: 'https://ru.wingie.com/pl/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
                { href: 'https://ru.wingie.com/pl/flights/airlines/utair/', title: 'Utair' },
            ],
        },
    ],
    'ru-lt': [
        {
            title: 'Populiariausi maršrutai',
            items: [
                { href: 'https://ru.wingie.com/lt/flights/to-moscow/', title: 'Maskva' },
                { href: 'https://ru.wingie.com/lt/flights/to-vladivostok/', title: 'Vladivostokas' },
                { href: 'https://ru.wingie.com/lt/flights/to-krasnodar/', title: 'Krasnodaris' },
                { href: 'https://ru.wingie.com/lt/flights/to-new-york/', title: 'Niujorkas' },
                { href: 'https://ru.wingie.com/lt/flights/to-london/', title: 'Londonas' },
                { href: 'https://ru.wingie.com/lt/flights/to-amsterdam/', title: 'Amsterdamas' },
            ],
        },
        {
            title: 'Populiarios šalys',
            items: [
                { href: 'https://ru.wingie.com/lt/flights/am-armenia/', title: 'Armėnija' },
                { href: 'https://ru.wingie.com/lt/flights/az-azerbaijan/', title: 'Azerbaidžanas' },
                { href: 'https://ru.wingie.com/lt/flights/by-belarus/', title: 'Baltarusija' },
                { href: 'https://ru.wingie.com/lt/flights/eg-egypt/', title: 'Egiptas' },
                { href: 'https://ru.wingie.com/lt/flights/ge-georgia/', title: 'Gruzija' },
                { href: 'https://ru.wingie.com/lt/flights/in-india/', title: 'Indija' },
            ],
        },
        {
            title: 'Populiarios oro linijos',
            items: [
                { href: 'https://ru.wingie.com/lt/flights/airlines/azerbaijan-airlines/', title: 'Azerbaijan Airlines' },
                { href: 'https://ru.wingie.com/lt/flights/airlines/pobeda/', title: 'Pobeda' },
                { href: 'https://ru.wingie.com/lt/flights/airlines/nordwind-airlines/', title: 'Nordwind Airlines' },
                { href: 'https://ru.wingie.com/lt/flights/airlines/rossiya-russian-airlines/', title: 'Rossiya-Russian Airlines' },
                { href: 'https://ru.wingie.com/lt/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
                { href: 'https://ru.wingie.com/lt/flights/airlines/utair/', title: 'Utair' },
            ],
        },
    ],
    'ru-uz': [
        {
            title: "Mashhur yo'nalishlar",
            items: [
                { href: 'https://ru.wingie.com/uz/flights/to-moscow/', title: 'Moskva' },
                { href: 'https://ru.wingie.com/uz/flights/to-vladivostok/', title: 'Vladivostok' },
                { href: 'https://ru.wingie.com/uz/flights/to-krasnodar/', title: 'Krasnodar' },
                { href: 'https://ru.wingie.com/uz/flights/to-new-york/', title: 'Nyu-York' },
                { href: 'https://ru.wingie.com/uz/flights/to-london/', title: 'London' },
                { href: 'https://ru.wingie.com/uz/flights/to-amsterdam/', title: 'Amsterdam' },
            ],
        },
        {
            title: 'Mashhur davlatlar',
            items: [
                { href: 'https://ru.wingie.com/uz/flights/am-armaniston/', title: 'Armaniston' },
                { href: 'https://ru.wingie.com/uz/flights/az-ozarbayjon/', title: 'Ozarbayjon' },
                { href: 'https://ru.wingie.com/uz/flights/by-belarus/', title: 'Belarus' },
                { href: 'https://ru.wingie.com/uz/flights/eg-misr/', title: 'Misr' },
                { href: 'https://ru.wingie.com/uz/flights/ge-gruziya/', title: 'Gruziya' },
                { href: 'https://ru.wingie.com/uz/flights/in-hindiston/', title: 'Hindiston' },
            ],
        },
        {
            title: 'Mashhur aviakompaniyalar',
            items: [
                { href: 'https://ru.wingie.com/uz/flights/airlines/azerbaijan-airlines/', title: 'Azerbaijan Airlines' },
                { href: 'https://ru.wingie.com/uz/flights/airlines/pobeda/', title: 'Pobeda' },
                { href: 'https://ru.wingie.com/uz/flights/airlines/nordwind-airlines/', title: 'Nordwind Airlines' },
                { href: 'https://ru.wingie.com/uz/flights/airlines/rossiya-russian-airlines/', title: 'Rossiya-Russian Airlines' },
                { href: 'https://ru.wingie.com/uz/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
                { href: 'https://ru.wingie.com/uz/flights/airlines/utair/', title: 'Utair' },
            ],
        },
    ],
    'ru-sr': [
        {
            title: 'Популарне дестинације',
            items: [
                { href: 'https://ru.wingie.com/sr/flights/to-moscow/', title: 'Москва' },
                { href: 'https://ru.wingie.com/sr/flights/to-vladivostok/', title: 'Владивосток' },
                { href: 'https://ru.wingie.com/sr/flights/to-krasnodar/', title: 'Краснодар' },
                { href: 'https://ru.wingie.com/sr/flights/to-new-york/', title: 'Њујорк' },
                { href: 'https://ru.wingie.com/sr/flights/to-london/', title: 'Лондон' },
                { href: 'https://ru.wingie.com/sr/flights/to-amsterdam/', title: 'Амстердам' },
            ],
        },
        {
            title: 'Популарне земље',
            items: [
                { href: 'https://ru.wingie.com/sr/flights/am-jermenija/', title: 'Јерменија' },
                { href: 'https://ru.wingie.com/sr/flights/az-azerbejdzan/', title: 'Азербејџан' },
                { href: 'https://ru.wingie.com/sr/flights/by-belorusija/', title: 'Белорусија' },
                { href: 'https://ru.wingie.com/sr/flights/eg-egipat/', title: 'Египат' },
                { href: 'https://ru.wingie.com/sr/flights/ge-gruzija/', title: 'Грузија' },
                { href: 'https://ru.wingie.com/sr/flights/in-indija/', title: 'Индија' },
            ],
        },
        {
            title: 'Популарне авио-компаније',
            items: [
                { href: 'https://ru.wingie.com/sr/flights/airlines/azerbaijan-airlines/', title: 'Azerbaijan Airlines' },
                { href: 'https://ru.wingie.com/sr/flights/airlines/pobeda/', title: 'Pobeda' },
                { href: 'https://ru.wingie.com/sr/flights/airlines/nordwind-airlines/', title: 'Nordwind Airlines' },
                { href: 'https://ru.wingie.com/sr/flights/airlines/rossiya-russian-airlines/', title: 'Rossiya-Russian Airlines' },
                { href: 'https://ru.wingie.com/sr/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
                { href: 'https://ru.wingie.com/sr/flights/airlines/utair/', title: 'Utair' },
            ],
        },
    ],
    'ru-ky': [
        {
            title: 'Популярдуу багыттар',
            items: [
                { href: 'https://ru.wingie.com/ky/учуштар/to-moscow/', title: 'Москва' },
                { href: 'https://ru.wingie.com/ky/учуштар/to-vladivostok/', title: 'Владивосток' },
                { href: 'https://ru.wingie.com/ky/учуштар/to-krasnodar/', title: 'Краснодар' },
                { href: 'https://ru.wingie.com/ky/учуштар/to-new-york/', title: 'Нью-Йорк' },
                { href: 'https://ru.wingie.com/ky/учуштар/to-london/', title: 'Лондон' },
                { href: 'https://ru.wingie.com/ky/учуштар/to-amsterdam/', title: 'Амстердам' },
            ],
        },
        {
            title: 'Популярдуу өлкөлөр',
            items: [
                { href: 'https://ru.wingie.com/ky/учуштар/am-armenya/', title: 'Армения' },
                { href: 'https://ru.wingie.com/ky/учуштар/az-azerbyzhan/', title: 'Азербайжан' },
                { href: 'https://ru.wingie.com/ky/учуштар/by-belarus/', title: 'Беларусь' },
                { href: 'https://ru.wingie.com/ky/учуштар/eg-mesir/', title: 'Мысыр' },
                { href: 'https://ru.wingie.com/ky/учуштар/ge-gruziya/', title: 'Грузия' },
                { href: 'https://ru.wingie.com/ky/учуштар/in-indya/', title: 'Индия' },
            ],
        },
        {
            title: 'Популярдуу авиакомпаниялар',
            items: [
                { href: 'https://ru.wingie.com/ky/учуштар/airlines/azerbaijan-airlines/', title: 'Azerbaijan Airlines' },
                { href: 'https://ru.wingie.com/ky/учуштар/airlines/pobeda/', title: 'Pobeda' },
                { href: 'https://ru.wingie.com/ky/учуштар/airlines/nordwind-airlines/', title: 'Nordwind Airlines' },
                { href: 'https://ru.wingie.com/ky/учуштар/airlines/rossiya-russian-airlines/', title: 'Rossiya-Russian Airlines' },
                { href: 'https://ru.wingie.com/ky/учуштар/airlines/s7-airlines/', title: 'S7 Airlines' },
                { href: 'https://ru.wingie.com/ky/учуштар/airlines/utair/', title: 'Utair' },
            ],
        },
    ],
    'ru-tg': [
        {
            title: 'Самаратарин ҷоҳои сафар',
            items: [
                { href: 'https://ru.wingie.com/tg/flights/to-moskva/', title: 'Москва' },
                { href: 'https://ru.wingie.com/tg/flights/to-vladivostok/', title: 'Владивосток' },
                { href: 'https://ru.wingie.com/tg/flights/to-krasnodar/', title: 'Краснодар' },
                { href: 'https://ru.wingie.com/tg/flights/to-new-york/', title: 'Ню-Йорк' },
                { href: 'https://ru.wingie.com/tg/flights/to-london/', title: 'Лондон' },
                { href: 'https://ru.wingie.com/tg/flights/to-amsterdam/', title: 'Амстердам' },
            ],
        },
        {
            title: 'Кишварҳои машҳур',
            items: [
                { href: 'https://ru.wingie.com/tg/flights/am-armaniston/', title: 'Арманистон' },
                { href: 'https://ru.wingie.com/tg/flights/az-ozarboyzhon/', title: 'Озарбойҷон' },
                { href: 'https://ru.wingie.com/tg/flights/by-belarus/', title: 'Беларус' },
                { href: 'https://ru.wingie.com/tg/flights/eg-misr/', title: 'Миср' },
                { href: 'https://ru.wingie.com/tg/flights/ge-gruziya/', title: 'Гурҷистон' },
                { href: 'https://ru.wingie.com/tg/flights/in-hinduston/', title: 'Ҳиндустон' },
            ],
        },
        {
            title: 'Компанияҳои машҳури парвозӣ',
            items: [
                { href: 'https://ru.wingie.com/tg/flights/airlines/azerbaijan-airlines/', title: 'Azerbaijan Airlines' },
                { href: 'https://ru.wingie.com/tg/flights/airlines/pobeda/', title: 'Pobeda' },
                { href: 'https://ru.wingie.com/tg/flights/airlines/nordwind-airlines/', title: 'Nordwind Airlines' },
                { href: 'https://ru.wingie.com/tg/flights/airlines/rossiya-russian-airlines/', title: 'Rossiya-Russian Airlines' },
                { href: 'https://ru.wingie.com/tg/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
                { href: 'https://ru.wingie.com/tg/flights/airlines/utair/', title: 'Utair' },
            ],
        },
    ],
    'ru-kk': [
        {
            title: 'Танымал бағыттар',
            items: [
                { href: 'https://ru.wingie.com/kk/flights/to-moscow/', title: 'Мәскеу' },
                { href: 'https://ru.wingie.com/kk/flights/to-vladivostok/', title: 'Владивосток' },
                { href: 'https://ru.wingie.com/kk/flights/to-krasnodar/', title: 'Краснодар' },
                { href: 'https://ru.wingie.com/kk/flights/to-new-york/', title: 'Нью-Йорк' },
                { href: 'https://ru.wingie.com/kk/flights/to-london/', title: 'Лондон' },
                { href: 'https://ru.wingie.com/kk/flights/to-amsterdam/', title: 'Амстердам' },
            ],
        },
        {
            title: 'Танымал елдер',
            items: [
                { href: 'https://ru.wingie.com/kk/flights/am-armenya/', title: 'Армения' },
                { href: 'https://ru.wingie.com/kk/flights/az-azerbyzhan/', title: 'Әзербайжан' },
                { href: 'https://ru.wingie.com/kk/flights/by-belarus/', title: 'Беларусь' },
                { href: 'https://ru.wingie.com/kk/flights/eg-mesir/', title: 'Мысыр' },
                { href: 'https://ru.wingie.com/kk/flights/ge-gruziya/', title: 'Грузия' },
                { href: 'https://ru.wingie.com/kk/flights/in-hindystan/', title: 'Үндістан' },
            ],
        },
        {
            title: 'Танымал авиакомпаниялар',
            items: [
                { href: 'https://ru.wingie.com/kk/flights/airlines/azerbaijan-airlines/', title: 'Azerbaijan Airlines' },
                { href: 'https://ru.wingie.com/kk/flights/airlines/pobeda/', title: 'Pobeda' },
                { href: 'https://ru.wingie.com/kk/flights/airlines/nordwind-airlines/', title: 'Nordwind Airlines' },
                { href: 'https://ru.wingie.com/kk/flights/airlines/rossiya-russian-airlines/', title: 'Rossiya-Russian Airlines' },
                { href: 'https://ru.wingie.com/kk/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
                { href: 'https://ru.wingie.com/kk/flights/airlines/utair/', title: 'Utair' },
            ],
        },
    ],
    'ru-nl': [
        {
            title: 'Populaire bestemmingen',
            items: [
                { href: 'https://ru.wingie.com/nl/flights/to-moscow/', title: 'Moskou' },
                { href: 'https://ru.wingie.com/nl/flights/to-vladivostok/', title: 'Vladivostok' },
                { href: 'https://ru.wingie.com/nl/flights/to-krasnodar/', title: 'Krasnodar' },
                { href: 'https://ru.wingie.com/nl/flights/to-new-york/', title: 'New York' },
                { href: 'https://ru.wingie.com/nl/flights/to-london/', title: 'Londen' },
                { href: 'https://ru.wingie.com/nl/flights/to-amsterdam/', title: 'Amsterdam' },
            ],
        },
        {
            title: 'Populaire landen',
            items: [
                { href: 'https://ru.wingie.com/nl/flights/am-armenie/', title: 'Armenië' },
                { href: 'https://ru.wingie.com/nl/flights/az-azerbaidjan/', title: 'Azerbeidzjan' },
                { href: 'https://ru.wingie.com/nl/flights/by-wit-rusland/', title: 'Wit-Rusland' },
                { href: 'https://ru.wingie.com/nl/flights/eg-egypte/', title: 'Egypte' },
                { href: 'https://ru.wingie.com/nl/flights/ge-georgie/', title: 'Georgië' },
                { href: 'https://ru.wingie.com/nl/flights/in-india/', title: 'India' },
            ],
        },
        {
            title: 'Populaire luchtvaartmaatschappijen',
            items: [
                { href: 'https://ru.wingie.com/nl/flights/airlines/azerbaijan-airlines/', title: 'Azerbaijan Airlines' },
                { href: 'https://ru.wingie.com/nl/flights/airlines/pobeda/', title: 'Pobeda' },
                { href: 'https://ru.wingie.com/nl/flights/airlines/nordwind-airlines/', title: 'Nordwind Airlines' },
                { href: 'https://ru.wingie.com/nl/flights/airlines/rossiya-russian-airlines/', title: 'Rossiya-Russian Airlines' },
                { href: 'https://ru.wingie.com/nl/flights/airlines/s7-airlines/', title: 'S7 Airlines' },
                { href: 'https://ru.wingie.com/nl/flights/airlines/utair/', title: 'Utair' },
            ],
        },
    ],
    'ru-ja': [
        {
            title: '人気の目的地',
            items: [
                { title: 'ラスベガス', href: 'https://ru.wingie.com/ja/flights/to-las-vegas/' },
                { title: 'シカゴ', href: 'https://ru.wingie.com/ja/flights/to-chicago/' },
                { title: 'マイアミ', href: 'https://ru.wingie.com/ja/flights/to-miami/' },
                { title: 'カンクン', href: 'https://ru.wingie.com/ja/flights/to-cancun/' },
                { title: 'ロンドン', href: 'https://ru.wingie.com/ja/flights/to-london/' },
                { title: 'ホノルル', href: 'https://ru.wingie.com/ja/flights/to-honolulu/' },
            ],
        },
        {
            title: '人気の国',
            items: [
                { title: 'カナダ', href: 'https://ru.wingie.com/ja/flights/ca-canada/' },
                { title: '中国', href: 'https://ru.wingie.com/ja/flights/cn-china/' },
                { title: 'コスタリカ', href: 'https://ru.wingie.com/ja/flights/cr-costa-rica/' },
                { title: 'ドミニカ共和国', href: 'https://ru.wingie.com/ja/flights/do-dominican-republic/' },
                { title: 'エルサルバドル', href: 'https://ru.wingie.com/ja/flights/sv-el-salvador/' },
                { title: 'フランス', href: 'https://ru.wingie.com/ja/flights/fr-france/' },
            ],
        },
        {
            title: '人気の航空会社',
            items: [
                { title: 'アメリカン・エアラインズ', href: 'https://ru.wingie.com/ja/flights/airlines/american-airlines/' },
                { title: 'デルタ航空', href: 'https://ru.wingie.com/ja/flights/airlines/delta-air-lines/' },
                { title: 'ユナイテッド航空', href: 'https://ru.wingie.com/ja/flights/airlines/united-airlines/' },
                { title: 'アラスカ航空', href: 'https://ru.wingie.com/ja/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ru.wingie.com/ja/flights/airlines/jetblue/' },
                { title: 'ハワイアン航空', href: 'https://ru.wingie.com/ja/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ru-zh': [
        {
            title: '热门目的地',
            items: [
                { title: '拉斯维加斯', href: 'https://ru.wingie.com/zh/flights/to-las-vegas/' },
                { title: '芝加哥', href: 'https://ru.wingie.com/zh/flights/to-chicago/' },
                { title: '迈阿密', href: 'https://ru.wingie.com/zh/flights/to-miami/' },
                { title: '坎昆', href: 'https://ru.wingie.com/zh/flights/to-cancun/' },
                { title: '伦敦', href: 'https://ru.wingie.com/zh/flights/to-london/' },
                { title: '火奴鲁鲁', href: 'https://ru.wingie.com/zh/flights/to-honolulu/' },
            ],
        },
        {
            title: '热门国家',
            items: [
                { title: '加拿大', href: 'https://ru.wingie.com/zh/flights/ca-canada/' },
                { title: '中国', href: 'https://ru.wingie.com/zh/flights/cn-china/' },
                { title: '哥斯达黎加', href: 'https://ru.wingie.com/zh/flights/cr-costa-rica/' },
                { title: '多米尼加共和国', href: 'https://ru.wingie.com/zh/flights/do-dominican-republic/' },
                { title: '萨尔瓦多', href: 'https://ru.wingie.com/zh/flights/sv-el-salvador/' },
                { title: '法国', href: 'https://ru.wingie.com/zh/flights/fr-france/' },
            ],
        },
        {
            title: '热门航空公司',
            items: [
                { title: '美国航空', href: 'https://ru.wingie.com/zh/flights/airlines/american-airlines/' },
                { title: '达美航空', href: 'https://ru.wingie.com/zh/flights/airlines/delta-air-lines/' },
                { title: '美联航', href: 'https://ru.wingie.com/zh/flights/airlines/united-airlines/' },
                { title: '阿拉斯加航空', href: 'https://ru.wingie.com/zh/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ru.wingie.com/zh/flights/airlines/jetblue/' },
                { title: '夏威夷航空', href: 'https://ru.wingie.com/zh/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ru-ko': [
        {
            title: '인기 목적지',
            items: [
                { title: '라스베이거스', href: 'https://ru.wingie.com/ko/flights/to-las-vegas/' },
                { title: '시카고', href: 'https://ru.wingie.com/ko/flights/to-chicago/' },
                { title: '마이애미', href: 'https://ru.wingie.com/ko/flights/to-miami/' },
                { title: '칸쿤', href: 'https://ru.wingie.com/ko/flights/to-cancun/' },
                { title: '런던', href: 'https://ru.wingie.com/ko/flights/to-london/' },
                { title: '호놀룰루', href: 'https://ru.wingie.com/ko/flights/to-honolulu/' },
            ],
        },
        {
            title: '인기 국가',
            items: [
                { title: '캐나다', href: 'https://ru.wingie.com/ko/flights/ca-canada/' },
                { title: '중국', href: 'https://ru.wingie.com/ko/flights/cn-china/' },
                { title: '코스타리카', href: 'https://ru.wingie.com/ko/flights/cr-costa-rica/' },
                { title: '도미니카 공화국', href: 'https://ru.wingie.com/ko/flights/do-dominican-republic/' },
                { title: '엘살바도르', href: 'https://ru.wingie.com/ko/flights/sv-el-salvador/' },
                { title: '프랑스', href: 'https://ru.wingie.com/ko/flights/fr-france/' },
            ],
        },
        {
            title: '인기 항공사',
            items: [
                { title: '아메리칸 항공', href: 'https://ru.wingie.com/ko/flights/airlines/american-airlines/' },
                { title: '델타 항공', href: 'https://ru.wingie.com/ko/flights/airlines/delta-air-lines/' },
                { title: '유나이티드 항공', href: 'https://ru.wingie.com/ko/flights/airlines/united-airlines/' },
                { title: '알래스카 항공', href: 'https://ru.wingie.com/ko/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ru.wingie.com/ko/flights/airlines/jetblue/' },
                { title: '하와이안 항공', href: 'https://ru.wingie.com/ko/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ru-hi': [
        {
            title: 'लोकप्रिय गंतव्य',
            items: [
                { title: 'लास वेगास', href: 'https://ru.wingie.com/hi/flights/to-las-vegas/' },
                { title: 'शिकागो', href: 'https://ru.wingie.com/hi/flights/to-chicago/' },
                { title: 'मियामी', href: 'https://ru.wingie.com/hi/flights/to-miami/' },
                { title: 'कैनकन', href: 'https://ru.wingie.com/hi/flights/to-cancun/' },
                { title: 'लंदन', href: 'https://ru.wingie.com/hi/flights/to-london/' },
                { title: 'होनोलुलु', href: 'https://ru.wingie.com/hi/flights/to-honolulu/' },
            ],
        },
        {
            title: 'लोकप्रिय देश',
            items: [
                { title: 'कनाडा', href: 'https://ru.wingie.com/hi/flights/ca-canada/' },
                { title: 'चीन', href: 'https://ru.wingie.com/hi/flights/cn-china/' },
                { title: 'कोस्टा रिका', href: 'https://ru.wingie.com/hi/flights/cr-costa-rica/' },
                { title: 'डोमिनिकन गणराज्य', href: 'https://ru.wingie.com/hi/flights/do-dominican-republic/' },
                { title: 'अल सल्वाडोर', href: 'https://ru.wingie.com/hi/flights/sv-el-salvador/' },
                { title: 'फ्रांस', href: 'https://ru.wingie.com/hi/flights/fr-france/' },
            ],
        },
        {
            title: 'लोकप्रिय एयरलाइनें',
            items: [
                { title: 'अमेरिकन एयरलाइन्स', href: 'https://ru.wingie.com/hi/flights/airlines/american-airlines/' },
                { title: 'डेल्टा एयरलाइन्स', href: 'https://ru.wingie.com/hi/flights/airlines/delta-air-lines/' },
                { title: 'यूनाइटेड एयरलाइन्स', href: 'https://ru.wingie.com/hi/flights/airlines/united-airlines/' },
                { title: 'अलास्का एयरलाइन्स', href: 'https://ru.wingie.com/hi/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ru.wingie.com/hi/flights/airlines/jetblue/' },
                { title: 'हवाई एयरलाइन्स', href: 'https://ru.wingie.com/hi/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ru-ta': [
        {
            title: 'பிரபலமான இலக்குகள்',
            items: [
                { title: 'லாஸ் வெகாஸ்', href: 'https://ru.wingie.com/ta/flights/to-las-vegas/' },
                { title: 'சிகாகோ', href: 'https://ru.wingie.com/ta/flights/to-chicago/' },
                { title: 'மியாமி', href: 'https://ru.wingie.com/ta/flights/to-miami/' },
                { title: 'கான்கன்', href: 'https://ru.wingie.com/ta/flights/to-cancun/' },
                { title: 'லண்டன்', href: 'https://ru.wingie.com/ta/flights/to-london/' },
                { title: 'ஓனோலுலு', href: 'https://ru.wingie.com/ta/flights/to-honolulu/' },
            ],
        },
        {
            title: 'பிரபலமான நாடுகள்',
            items: [
                { title: 'கனடா', href: 'https://ru.wingie.com/ta/flights/ca-canada/' },
                { title: 'சீனா', href: 'https://ru.wingie.com/ta/flights/cn-china/' },
                { title: 'கோஸ்டா ரிக்கா', href: 'https://ru.wingie.com/ta/flights/cr-costa-rica/' },
                { title: 'டொமினிக்கன் குடியரசு', href: 'https://ru.wingie.com/ta/flights/do-dominican-republic/' },
                { title: 'எல் சால்வடோர்', href: 'https://ru.wingie.com/ta/flights/sv-el-salvador/' },
                { title: 'பிரான்சு', href: 'https://ru.wingie.com/ta/flights/fr-france/' },
            ],
        },
        {
            title: 'பிரபலமான விமான நிறுவனங்கள்',
            items: [
                { title: 'அமெரிக்கன் ஏர்லைன்ஸ்', href: 'https://ru.wingie.com/ta/flights/airlines/american-airlines/' },
                { title: 'டெல்டா ஏர்லைன்ஸ்', href: 'https://ru.wingie.com/ta/flights/airlines/delta-air-lines/' },
                { title: 'யுனைட்டட் ஏர்லைன்ஸ்', href: 'https://ru.wingie.com/ta/flights/airlines/united-airlines/' },
                { title: 'அலாஸ்கா ஏர்லைன்ஸ்', href: 'https://ru.wingie.com/ta/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ru.wingie.com/ta/flights/airlines/jetblue/' },
                { title: 'ஹவாய் ஏர்லைன்ஸ்', href: 'https://ru.wingie.com/ta/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ru-th': [
        {
            title: 'จุดหมายยอดนิยม',
            items: [
                { title: 'ลาสเวกัส', href: 'https://ru.wingie.com/th/flights/to-las-vegas/' },
                { title: 'ชิคาโก', href: 'https://ru.wingie.com/th/flights/to-chicago/' },
                { title: 'ไมอามี', href: 'https://ru.wingie.com/th/flights/to-miami/' },
                { title: 'แคนคูน', href: 'https://ru.wingie.com/th/flights/to-cancun/' },
                { title: 'ลอนดอน', href: 'https://ru.wingie.com/th/flights/to-london/' },
                { title: 'โฮโนลูลู', href: 'https://ru.wingie.com/th/flights/to-honolulu/' },
            ],
        },
        {
            title: 'ประเทศยอดนิยม',
            items: [
                { title: 'แคนาดา', href: 'https://ru.wingie.com/th/flights/ca-canada/' },
                { title: 'จีน', href: 'https://ru.wingie.com/th/flights/cn-china/' },
                { title: 'คอสตาริกา', href: 'https://ru.wingie.com/th/flights/cr-costa-rica/' },
                { title: 'สาธารณรัฐโดมินิกัน', href: 'https://ru.wingie.com/th/flights/do-dominican-republic/' },
                { title: 'เอลซัลวาดอร์', href: 'https://ru.wingie.com/th/flights/sv-el-salvador/' },
                { title: 'ฝรั่งเศส', href: 'https://ru.wingie.com/th/flights/fr-france/' },
            ],
        },
        {
            title: 'สายการบินยอดนิยม',
            items: [
                { title: 'อเมริกันแอร์ไลน์', href: 'https://ru.wingie.com/th/flights/airlines/american-airlines/' },
                { title: 'เดลต้า แอร์ไลน์', href: 'https://ru.wingie.com/th/flights/airlines/delta-air-lines/' },
                { title: 'ยูไนเต็ด แอร์ไลน์', href: 'https://ru.wingie.com/th/flights/airlines/united-airlines/' },
                { title: 'อลาสก้าแอร์ไลน์', href: 'https://ru.wingie.com/th/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ru.wingie.com/th/flights/airlines/jetblue/' },
                { title: 'ฮาวายแอนแอร์ไลน์', href: 'https://ru.wingie.com/th/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ru-ur': [
        {
            title: 'مشہور منزلیں',
            items: [
                { title: 'لاس ویگاس', href: 'https://ru.wingie.com/ur/flights/to-las-vegas/' },
                { title: 'شکاگو', href: 'https://ru.wingie.com/ur/flights/to-chicago/' },
                { title: 'میامی', href: 'https://ru.wingie.com/ur/flights/to-miami/' },
                { title: 'کینکن', href: 'https://ru.wingie.com/ur/flights/to-cancun/' },
                { title: 'لندن', href: 'https://ru.wingie.com/ur/flights/to-london/' },
                { title: 'ہونولولو', href: 'https://ru.wingie.com/ur/flights/to-honolulu/' },
            ],
        },
        {
            title: 'مشہور ممالک',
            items: [
                { title: 'کینیڈا', href: 'https://ru.wingie.com/ur/flights/ca-canada/' },
                { title: 'چین', href: 'https://ru.wingie.com/ur/flights/cn-china/' },
                { title: 'کوسٹا ریکا', href: 'https://ru.wingie.com/ur/flights/cr-costa-rica/' },
                { title: 'ڈومینیکن جمہوریہ', href: 'https://ru.wingie.com/ur/flights/do-dominican-republic/' },
                { title: 'ایل سیلواڈور', href: 'https://ru.wingie.com/ur/flights/sv-el-salvador/' },
                { title: 'فرانس', href: 'https://ru.wingie.com/ur/flights/fr-france/' },
            ],
        },
        {
            title: 'مشہور ایئر لائنز',
            items: [
                { title: 'امریکن ایئرلائنز', href: 'https://ru.wingie.com/ur/flights/airlines/american-airlines/' },
                { title: 'ڈیلٹا ایئر لائنز', href: 'https://ru.wingie.com/ur/flights/airlines/delta-air-lines/' },
                { title: 'یونائیٹڈ ایئرلائنز', href: 'https://ru.wingie.com/ur/flights/airlines/united-airlines/' },
                { title: 'الاسکا ایئرلائنز', href: 'https://ru.wingie.com/ur/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ru.wingie.com/ur/flights/airlines/jetblue/' },
                { title: 'ہوائی ایئرلائنز', href: 'https://ru.wingie.com/ur/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'ru-ka': [
        {
            title: 'პოპულარული მიმართულებები',
            items: [
                { title: 'ლას-ვეგასი', href: 'https://ru.wingie.com/ka/flights/to-las-vegas/' },
                { title: 'ჩიკაგო', href: 'https://ru.wingie.com/ka/flights/to-chicago/' },
                { title: 'მაიამი', href: 'https://ru.wingie.com/ka/flights/to-miami/' },
                { title: 'კანკუნი', href: 'https://ru.wingie.com/ka/flights/to-cancun/' },
                { title: 'ლონდონი', href: 'https://ru.wingie.com/ka/flights/to-london/' },
                { title: 'ჰონოლულუ', href: 'https://ru.wingie.com/ka/flights/to-honolulu/' },
            ],
        },
        {
            title: 'პოპულარული ქვეყნები',
            items: [
                { title: 'კანადა', href: 'https://ru.wingie.com/ka/flights/ca-canada/' },
                { title: 'ჩინეთი', href: 'https://ru.wingie.com/ka/flights/cn-china/' },
                { title: 'კოსტა-რიკა', href: 'https://ru.wingie.com/ka/flights/cr-costa-rica/' },
                { title: 'დომინიკელთა რესპუბლიკა', href: 'https://ru.wingie.com/ka/flights/do-dominican-republic/' },
                { title: 'სალვადორი', href: 'https://ru.wingie.com/ka/flights/sv-el-salvador/' },
                { title: 'საფრანგეთი', href: 'https://ru.wingie.com/ka/flights/fr-france/' },
            ],
        },
        {
            title: 'პოპულარული ავიაკომპანიები',
            items: [
                { title: 'ამერიკის ავიაკომპანია', href: 'https://ru.wingie.com/ka/flights/airlines/american-airlines/' },
                { title: 'დელტა ეარ ლაინზი', href: 'https://ru.wingie.com/ka/flights/airlines/delta-air-lines/' },
                { title: 'იუნაიტედ ერლაინზი', href: 'https://ru.wingie.com/ka/flights/airlines/united-airlines/' },
                { title: 'ალასკას ავიაკომპანია', href: 'https://ru.wingie.com/ka/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://ru.wingie.com/ka/flights/airlines/jetblue/' },
                { title: 'ჰავაუს ავიაკომპანია', href: 'https://ru.wingie.com/ka/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ]
}